import {
  AdvancedFiltersDefaultInputs,
  createAdvancedFilterConfig,
} from '@autone/ui';

import { type AssortmentAdvancedFiltersTranslationsMap } from '../../../../hooks/use-assortment-advanced-filters';
import { type GetAssortmentProductsAdvancedFilterConditions } from '../../../../redux/assortment';

const NUMERIC_FIELD_OPERATORS = ['eq', 'gt', 'lt', 'ge', 'le'] as const;

export const getProductsTableAdvancedFilterConfig = ({
  fields,
  operators,
}: AssortmentAdvancedFiltersTranslationsMap) =>
  createAdvancedFilterConfig<GetAssortmentProductsAdvancedFilterConditions>({
    fieldOptions: {
      lifetime_sales_units: fields.lifetime_sales_units,
      lifetime_sales_value: fields.lifetime_sales_value,
      store_inventory_units: fields.store_inventory_units,
      warehouse_inventory_units: fields.warehouse_inventory_units,
      first_sale_date: fields.first_sale_date,
      latest_sale_date: fields.latest_sale_date,
      warehouse_pending_from_production_units:
        fields.warehouse_pending_from_production_units,
    },
    operatorOptions: {
      eq: operators.eq,
      gt: operators.gt,
      lt: operators.lt,
      ge: operators.ge,
      le: operators.le,
    },
    fieldConfigs: {
      lifetime_sales_units: {
        operators: NUMERIC_FIELD_OPERATORS,
        renderInput: ({ value, onValueChange }) => (
          <AdvancedFiltersDefaultInputs.Number
            min={0}
            value={value}
            onChange={(val) =>
              onValueChange(val !== null ? Number(val) : undefined)
            }
          />
        ),
      },
      lifetime_sales_value: {
        operators: NUMERIC_FIELD_OPERATORS,
        renderInput: ({ value, onValueChange }) => (
          <AdvancedFiltersDefaultInputs.Number
            min={0}
            value={value}
            onChange={(val) =>
              onValueChange(val !== null ? Number(val) : undefined)
            }
          />
        ),
      },
      store_inventory_units: {
        operators: NUMERIC_FIELD_OPERATORS,
        renderInput: ({ value, onValueChange }) => (
          <AdvancedFiltersDefaultInputs.Number
            min={0}
            value={value}
            onChange={(val) =>
              onValueChange(val !== null ? Number(val) : undefined)
            }
          />
        ),
      },
      warehouse_inventory_units: {
        operators: NUMERIC_FIELD_OPERATORS,
        renderInput: ({ value, onValueChange }) => (
          <AdvancedFiltersDefaultInputs.Number
            min={0}
            value={value}
            onChange={(val) =>
              onValueChange(val !== null ? Number(val) : undefined)
            }
          />
        ),
      },
      first_sale_date: {
        operators: NUMERIC_FIELD_OPERATORS,
        renderInput: ({ value, onValueChange }) => (
          <AdvancedFiltersDefaultInputs.SingleDate
            value={value}
            onValueChange={onValueChange}
          />
        ),
      },
      latest_sale_date: {
        operators: NUMERIC_FIELD_OPERATORS,
        renderInput: ({ value, onValueChange }) => (
          <AdvancedFiltersDefaultInputs.SingleDate
            value={value}
            onValueChange={onValueChange}
          />
        ),
      },
      warehouse_pending_from_production_units: {
        operators: NUMERIC_FIELD_OPERATORS,
        renderInput: ({ value, onValueChange }) => (
          <AdvancedFiltersDefaultInputs.Number
            min={0}
            value={value}
            onChange={(val) =>
              onValueChange(val !== null ? Number(val) : undefined)
            }
          />
        ),
      },
    },
  });
